export const TITLE_LIST = [
  {'name': 'Please select', 'value': ''},
  {'name': 'Dr', 'value': 'Dr'},
  {'name': 'Miss', 'value': 'Miss'},  
  {'name': 'Mr', 'value': 'Mr'},
  {'name': 'Mrs', 'value': 'Mrs'},
  {'name': 'Ms', 'value': 'Ms'}
]

export const STATE_LIST = [
  {'name': 'Please select', 'value': ''},
  {'name': 'VIC', 'value': 'VIC'},
  {'name': 'NSW', 'value': 'NSW'},
  {'name': 'QLD', 'value': 'QLD'},
  {'name': 'WA', 'value': 'WA'},
  {'name': 'TAS', 'value': 'TAS'},
  {'name': 'SA', 'value': 'SA'},
  {'name': 'ACT', 'value': 'ACT'},
  {'name': 'NT', 'value': 'NT'}
]

export const WORK_CATEGORY_LIST = [
  {
    'category': 'Building & works - private residence',
    'examples': [
      'Existing and proposed site plans.',
      'Existing and proposed floor plans.',
      'Existing and proposed elevations.',
      'Materials and colour schedule.',
      'Photo montages and a site plan showing the extent of heritage registration overlayed.'
    ],
    'types': [
      'Plans',
      'Materials and colour schedule',
      'Images',
      'Specification'
    ]
  },
  {
    'category': 'Building & works - non-residential',
    'examples': [
      'Existing and proposed site plans.',
      'Existing and proposed floor plans.',
      'Existing and proposed elevations.',
      'Materials and colour schedule.',
      'Photo montages and a site plan showing the extent of heritage registration overlayed.'
    ],
    'types': [
      'Plans',
      'Materials and colour schedule',
      'Images',
      'Specification'
    ]
  },
  { 
    'category': 'Landscape works',
    'examples': [
      'Existing conditions plan and photographs.',
      'Proposed landscape plan(s).',
      'Tree reports if tree removal proposed.',
    ],
    'types': [
      'Plans',
      'Tree reports',
      'Images',
      'Specification'
    ]
  },
  { 
    'category': 'Subdivision/consolidation',
    'examples': [
      'Existing lot arrangement/site plan.',
      'Subdivision plan prepared by a licensed surveyor showing existing heritage buildings and extent of heritage registration overlayed.'
    ],
    'types': [
      'Plans'
    ]
  },
  { 
    'category': 'Painting',
    'examples': [
      'Sketch or elevation showing component colours (e.g. roof, walls, gutters, downpipes etc.).',
      'Colour chips of proposed colours.',
      'Colour chips of current colours.',
      'Rationale for proposed colour scheme.',
      'Job specification setting out details of preparatory work.'
    ],
    'types': [
      'Colour Plans',
      'Painting preparatory work',
      'Images',
      'Specification'
    ]
  },
  { 
    'category': 'Re-roofing',
    'examples': [
      'Details of existing roofing materials.',
      'Schedule of proposed roofing materials.',
      'Rationale for proposed materials if different from existing.',
      'Roof plans—existing and proposed.',
      'Job specification setting out work methods.'
    ],
    'types': [
      'Roof Plans',
      'Method of Works',
      'Images',
      'Specification'
    ]
  },
  { 
    'category': 'Signage',
    'examples': [
      'Plans showing any existing signage.',
      'Plans showing proposed signage including retention of existing signage.',
      'Specifications of signs including form, dimensions, materials and whether illuminated.',
      'Details of how signs will be affixed to a heritage building or structure.'
    ],
    'types': [
      'Signage Details',
      'Images',
      'Specification'
    ]
  },
  { 
    'category': 'Conservation works',
    'examples': [
      'Existing and proposed site plans.',
      'Existing and proposed floor plans.',
      'Existing and proposed elevations.',
      'Materials and colour schedule.',
      'Photo montages and a site plan showing the extent of heritage registration overlayed.'
    ],
    'types': [
      'Plans',
      'Materials and colour schedule',
      'Images',
      'Specification'
    ]
  },
  { 
    'category': 'Adaptive re-use',
    'examples': [
      'Existing and proposed site plans.',
      'Existing and proposed floor plans.',
      'Existing and proposed elevations.',
      'Materials and colour schedule.',
      'Photo montages and a site plan showing the extent of heritage registration overlayed.'
    ],
    'types': [
      'Plans',
      'Materials and colour schedule',
      'Images',
      'Specification'
    ]
  },
  { 
    'category': 'Archaeology',
    'examples': [
      'Site plans.',
      'Research Design.',
      'Artefact Retention Policy.',
      'Artefact Management Proposal.',
      'Curriculum vitae of the project archaeologist and conservator.',
      'Letter detailing engagement of project conservator.'
    ],
    'types': [
      'Plans',
      'Research Design',
      'Artefact Management',
      'Conservator Details'
    ]
  }
]

export const TYPE_ACTIVITY_LIST = [
  {
    'category': 'The works are for the purposes of conservation or research of a registered place or a registered object, (r26a Heritage Regulations 2017)',
    'regulation' : 'r26(a)'
  },
  {
    'category': 'The works are to educate the public as to the cultural heritage significance of the registered place or object (r26b Heritage Regulations 2017)',
    'examples': [
      'A registered place, a registered object, an archaeological site or an archaeological artefact (r26b Heritage Regulations 2017)'
    ],
    'regulation' : 'r26(b)'
  },
  {
    'category': 'The works are for the safety of the public (r26c Heritage Regulations 2017)',
    'regulation' : 'r26(c)'
  },
  {
    'category': 'The works are the same, or primarily the same, as those for which a permit has previously been issued to the applicant in relation to a registered place, a registered object, (r26d Heritage Regulations 2017)',
    'regulation' : 'r26(d)'
  },
  {
    'category': 'The applicant is a community group where community group means a not-for-profit society, association or club (other than a charity) (r26e Heritage Regulations 2017)',
    'examples': [
      '(a) established for the purpose of educating the community about, or to protect, a place or object; and',
      '(b) whose officers receive no remuneration or gratuity for their services to the society, association or club'
    ],
    'note' : 'You will be required to upload a Statutory Declaration or Club Charter or other evidence to demonstrate your eligibility.',
    'regulation' : 'r26(e)'
  }
]

export const ACTIVITIES_ESTIMATE_LIST = [
  {'name': 'Less than $10,000.', 'value': 'Less than $10,000.'},
  {'name': 'At least $10,000 but less than $20,000.', 'value': 'At least $10,000 but less than $20,000.'},
  {'name': 'At least $20,000 but less than $100,000.', 'value': 'At least $20,000 but less than $100,000.'},
  {'name': 'At least $100,000 but less than $250,000.', 'value': 'At least $100,000 but less than $250,000.'},
  {'name': 'At least $250,000 but less than $500,000.', 'value': 'At least $250,000 but less than $500,000.'},
  {'name': 'At least $500,000 but less than $1,000,000.', 'value': 'At least $500,000 but less than $1,000,000.'},
  {'name': 'At least $1,000,000 but less than $5,000,000.', 'value': 'At least $1,000,000 but less than $5,000,000.'},
  {'name': 'At least $5,000,000 but less than $10,000,000.', 'value': 'At least $5,000,000 but less than $10,000,000.'},
  {'name': 'At least $10,000,000 but less than $30,000,000.', 'value': 'At least $10,000,000 but less than $30,000,000.'},
  {'name': '$30,000,000 or more.', 'value': '$30,000,000 or more.'}
]